import React, { PureComponent } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { WithStyles, createStyles, Typography, Grid } from "@material-ui/core";
import { MyPATExpansionPanel } from "../../../common";
import Hints from "./Hints";
import AddExtraTags from "./AddExtraTags";
import AddDifficultyAndSkill from "./AddDifficultyAndSkill";
import RelevantExams from "./RelevantExams";
import AddConceptOrChapter from "./AddConceptOrChapter";
import { eventFired } from "../../actions/contentInSectionAction";
import { statusType } from "../../types/ContentInSection";
import QuestionTitleField from "./QuestionTitleField";
import ContentOptions from "./ContentOptions";
import contentActions from "../../actions/contentActions";
import { questionActions } from "../../reducers/questionCreateReducer";
import ContentAnswer from "./ContentAnswer";
import QuestionsSolution from "./QuestionsSolution";
import MatrixOptions from "./MatrixOptions";
import MatrixAnswers from "./MatrixAnswers";
import {
  validateTitle,
  validateOptions,
  validateAnswer,
  validateSyllabus,
  validateTags,
  validateQuestionHint,
  validateStepWiseSolutions,
  validateDifficultyAndSkillLevel,
  validateBenchmarks,
  getUserType,
  getPropertyValue
} from '../../../../utils';
import VarientQuestionCard from './VarientQuestionCard';
import { getVariationName } from "../../../../utils/getOffset.utils";
import AddBenchmarking from "./AddBenchmarking";
import { OptionSettingsType } from "../../types/ContentFormData";
import { CONTENT_SECTION_KEYS, CONTENT_SPECIAL_PURPOSES, CONTENT_TYPE, QUESTION_TYPES, USER_TYPE } from "../../../../constants/comman";
import { StepWiseSolution } from "../../types/ContentData";
import AddFeedback from "../../../content-request/components/AddFeedback";
import { addNewFeedback, resolveFeedback, replyFeedback } from "../../../content-request/actions/contentRequestActions";
import CustomInfoIcon from "../../../common/CustomInfoIcon";
import PreviousYearQuestion from "./PreviousYearQuestion";
import SetIdealTime from "./SetIdealTime";
import { convertTime } from "../../../../utils/getOffset.utils";
import AddFeedbackPopup from "./AddFeedbackPopup";
import { SECTIONS } from "../../helper/contentValidation";
import RemedialQuestion from "./RemedialComponent/RemedialQuestion";
import { remedialQuestionActions } from "../../reducers/remedialQuestionReducer";
import { PROPS_REMEDIAL_KEY } from "./RemedialComponent/RemedialQuestionConstants";

enum QuestionType {
  CORRECT_ANSWER = 'correctAnswer',
  OPTIONS_CONTENT = 'optionsContent'
}

const styles = (theme: Theme) => createStyles({
  feedbackContainer: {
		position: 'relative',
		'& .feedbackBlock': {
		  top: -16,
		  left: "100%",
		  position: "absolute",
		  marginLeft: 20,
		  zIndex: 2
		}
    },
    blueColor: {
      color: '#1D7DEA'
    },
  mb1x: {
    marginBottom: theme.spacing.unit,
  },
  mb2x: {
    marginBottom: theme.spacing.unit * 2,
  },
  cardHeading: {
    fontWeight: theme.typography.fontWeightRegular,
  },
  // shivam
  requiredHeading: {
    color: theme.palette.secondary.main,
  },
  borderBox: {
    background: "#FFFFFF",
    border: "1px solid #E1E1E1",
    boxSizing: "border-box",
    padding: theme.spacing.unit,
    borderRadius: 5,
  },
  optionColumn1: {
    paddingRight: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  adornedReorder: {
    cursor: "move",
    height: theme.spacing.unit * 4.5,
    padding: `0 ${theme.spacing.unit}px`,
    maxHeight: "unset",
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    "& svg": {
      fontSize: theme.spacing.unit * 3,
      color: theme.palette.grey[500],
    },
  },
  deleteHBtn: {
    border: `1px solid ${theme.palette.grey[300]}`,
    "& svg": {
      color: theme.palette.grey[600],
    },
  },
  reorderBtn: {
    border: `1px solid ${theme.palette.grey[300]}`,
    minWidth: theme.spacing.unit * 4,
    padding: `0 ${theme.spacing.unit}px`,
    "& svg": {
      color: theme.palette.grey[600],
    },
  },
  deleteVBtn: {
    border: `1px solid ${theme.palette.grey[300]}`,
    visibility: "visible",
    "& svg": {
      color: theme.palette.grey[600],
    },
  },
  addOptionButton: {
    marginLeft: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 2,
  },
  optionField: {
    "& > div": {
      marginBottom: 0,
    },
  },
  optionIdGrid: {
    minWidth: theme.spacing.unit * 4,
  },
  optionContent: {
    "& .btn-delete": {
      visibility: "hidden",
    },
    "&:hover .btn-delete": {
      visibility: "visible",
    },
  },
  paddingSet: {
    padding: "0 15px 0 0",
  },
  popupBlock: {
    width: "450px",
    textAlign: "center",
    "& p": {
      fontSize: "16px",
      "font-weight": "normal",
      lineHeight: "16px",
      textAlign: "center",
      letterSpacing: "0.144385px",
      color: "#000000",
      display: "block",
      paddingTop: "20px",
    },
  },
  attentionTitle: {
    fontSize: "16px",
    "font-weight": "500",
    lineHeight: "15px",
    textAlign: "center",
    letterSpacing: "0.144385px",
    color: "#000000",
    display: "block",
    paddingBottom: "18px",
  },
  feedbackHighlight:{
    cursor: 'pointer',
    '&:hover':{
      color: '#1d7dea',
    }
  },
 
});
interface OptionContent {
  id: string;
  value: string;
  serialNo: number;
}

interface MultipleChoiceCreateProps extends WithStyles<typeof styles> {
  eventFired: Function;
  type: string;
  subType: string;
  history: any;
  updateContent: Function;
  title: string;
  optionsContent: OptionContent;
  subjects: any;
  secondarySubjects: any;
  difficultyLevel: any;
  difficultyType: any;
  tags: any;
  validations: any;
  correctAnswer: any;
  isValidAttempts: boolean;
  customAnswer: boolean;
  questionHints: string;
  matrixOptionContent: any;
  matrixCorrectAnswer: any;
  tagsList: any;
  status: string;
  alternateAnswer: boolean;
  setTitle: Function;
  setOptionsContent: Function;
  setCorrectAnswer: Function;
  setCustomAnswer: Function;
  setQuestionHints: Function;
  setSubjects: Function;
  setDifficultyLevel: Function;
  setDifficultyType: Function;
  setRelevantExams: Function;
  setTags: Function;
  setMatrixOptionsContent: Function;
  setMatrixCorrectAnswer: Function;
  setValidations: Function;
  setAlternateAnswer: Function;
  contentId: string;
  optionSettings: OptionSettingsType;
  setSecondarySubjects: any;
  handleOptionSettingsChange: (type: string, value: any) => void;
  idealTime: any;
  setIdealTime: Function;
  content?: any;
  relevantExams: any;
  openFeedback: boolean;
  closeFeedback: Function;
  emptyClickedData: Function;
  authorType: string;
  contentRequestId: string;
  contentRequestItemId: string;
  addNewFeedback: Function;
  resolveFeedback: Function;
  replyFeedback: Function;
  clickedfeedbackData: any;
  handleFeedbackResolve: Function;
  feedbackData: any;
  editRights: string[];
  questionSpecialPurposes: any;
  activeValidationFeedbackSection?: string;
  activeValidationFeedbackData?: number;
  handleAddCommentInFeedback?: Function;
  createNewValidationFeedback?: Function;
  feedbackActionId?: string;
  setRemedialInitialState: Function;
  showRemedial: boolean
}
interface MultipleChoiceCreateState {
  tag: string,
  updatedDifficultyLevel: boolean
}
class MultipleChoiceCreate extends PureComponent<
  MultipleChoiceCreateProps,
  MultipleChoiceCreateState
> {
  isStudentUser: boolean = getUserType(USER_TYPE.STUDENT);
  constructor(props: MultipleChoiceCreateProps) {
    super(props);
    this.state = {
      tag: "question",
      updatedDifficultyLevel:false
    }
    this._setTitle = this._setTitle.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.getErrorText = this.getErrorText.bind(this);
    this.addNewFeedback = this.addNewFeedback.bind(this);
    this.resolveFeedback = this.resolveFeedback.bind(this);
    this.replyFeedback = this.replyFeedback.bind(this);
    this.closeFeedback = this.closeFeedback.bind(this);
    this.addFeedback = this.addFeedback.bind(this);
  }

  componentDidMount() {
    const { validations, subType } = this.props;
    this.props.setValidations(validations || this.getValidationObj(subType));
    this.props.setRemedialInitialState(1);
  }
  componentDidUpdate(prevProps: any) {

    if (this.props.validations && this.props.validations.addDifficultySkills && !this.state.updatedDifficultyLevel) {
      this.setState({ updatedDifficultyLevel: true }, () => {
        const studentUser = getUserType(USER_TYPE.STUDENT);
        !studentUser && this.props.setValidations(validateDifficultyAndSkillLevel(JSON.parse((JSON.stringify(this.props.validations))), { isDifficultyLevelPresent: (this.props.difficultyLevel || []).length, isDifficultyTypePresent: (this.props.difficultyType || []).length }));
      });
    }

    if(prevProps.clickedfeedbackData !== this.props.clickedfeedbackData) {
      if(!_.isEmpty(this.props.clickedfeedbackData)){

      this.setState({
        tag: this.props.clickedfeedbackData.tag
      })
    } else {
      this.setState({
        tag: 'question'
      })
    }
  }
  }
  addFeedback(tagName: string) {
    if(!_.isEmpty(this.props.clickedfeedbackData)){
      this.props.emptyClickedData();
    }
    
    let clickedfeedbackData = this.props.feedbackData && this.props.feedbackData.feedbacksData && this.props.feedbackData.feedbacksData.filter((feedback: any) =>
    feedback.tag === tagName && !feedback.isResolved
    );
     if(clickedfeedbackData && clickedfeedbackData.length > 0) {
     this.props.handleFeedbackResolve(clickedfeedbackData[0])
    }
    setTimeout(() => {

    if(this.props.openFeedback) {
      this.setState({
        tag: tagName
      })
    }
  }, 200 );
 

  }
  closeFeedback(){
    this.props.closeFeedback()
  }
  addNewFeedback(text: string) {
    let feedbackData = {
      contentRequestId: this.props.contentRequestId, 
      contentId: _.get(this.props.content, `content._id`, ""), 
      comment: text, 
      role: this.props.authorType, 
      tag: this.state.tag, 
      contentRequestItemId: this.props.contentRequestItemId, 
      contentType: 'question'
    }
    this.props.addNewFeedback(feedbackData)
    this.props.closeFeedback('resolve');
  }
  resolveFeedback(id: string) {
    let feedbackData = {
      feedbackId: id,
      role: this.props.authorType, 
      contentRequestItemId: this.props.contentRequestItemId, 
      contentType: 'question'
    }
    this.props.resolveFeedback(feedbackData)
    this.props.closeFeedback('resolve');
  }
  replyFeedback(id: string, text: string) {
    let feedbackData = {
      feedbackId: id,
      contentRequestId: this.props.contentRequestId, 
      contentId: _.get(this.props.content, `content._id`, ""), 
      comment: text, 
      role: this.props.authorType, 
      tag: this.state.tag, 
      contentRequestItemId: this.props.contentRequestItemId, 
      contentType: 'question'
    }
    this.props.replyFeedback(feedbackData)
    this.props.closeFeedback('resolve');
  }

  getValidationObj = (subType: string) => {
    const studentUser = getUserType(USER_TYPE.STUDENT);
    const initialValidations: any = {
      questionContent: {
        error: "",
        status: statusType.none,
      },
      optionsContent: {
        error: "Option can not be blank.",
        status: statusType.none,
        type: "options",
      },
      solutions: {
        error: "Steps cannot be blank.",
        status: statusType.none,
        type: "step", // can be step or weightage
        isEmptyWeightage: true,
      },
      correctAnswer: {
        error: "Answer must be entered.",
        status: statusType.none,
      },
      mapSyllabus: {
        error: "Atleast one concept must be mapped.",
        status: statusType.none,
      },
      // solutionContent: {
      //   error: "",
      //   status: statusType.none,
      // },
      'addDifficultySkills': {
        error: "Add difficulty & skill level",
        status: statusType.none,
      },
      'addBenchmarking': {
        error: "Add Benchmarking",
        status: statusType.none,
      }
    };
    if (studentUser) {
      delete initialValidations.addDifficultySkills;
      delete initialValidations.solutions;
    }
    if (_.includes(["3", "4", "7", "6"], subType)) {
      //@ts-ignore
      delete initialValidations["optionsContent"];
      // if (subType == "4") {
      //   delete initialValidations["solutionContent"];
      // }
      if (subType === "4") {
        // @ts-ignore
        delete initialValidations["correctAnswer"];
      }
    }
    const { questionSpecialPurposes } = this.props;
    if (questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE)) {
      // @ts-ignore
      delete initialValidations["addDifficultySkills"];
    }
    const nonGlorifireSet = new Set([CONTENT_SECTION_KEYS.AITS, CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST]);
    const isGlorifireOrFTREBucket = !questionSpecialPurposes.some((value: any) => nonGlorifireSet.has(value))
    if (isGlorifireOrFTREBucket) {
      // @ts-ignore
      delete initialValidations["addBenchmarking"];
    }
    return initialValidations;
  };

  _setTitle(evt: any) {
    const { name, value } = evt.target;
    const { validations } = this.props;
    const validationsCopy = JSON.parse(JSON.stringify(validations));
    this.props.setValidations(validateTitle(validationsCopy, value));
    this.props.setTitle(value);
  }

  _setMatrixOptionContent = (obj: any) => {
    const { validations, subType } = this.props;
    const validationsCopy = JSON.parse(JSON.stringify(validations));
    const { matrixOptionContent, matrixCorrectAnswer } = obj;
    this.props.setValidations(
      validateOptions(validationsCopy, {
        optionContent: { options: matrixOptionContent, subType },
        optionSettings: this.props.optionSettings,
      })
    );
    this.props.setMatrixOptionsContent(matrixOptionContent);
    if (matrixCorrectAnswer) {
      this._setMatrixCorrectAnswer(matrixCorrectAnswer);
    }
  };

  _setMatrixCorrectAnswer = (value: any) => {
    const { validations, subType } = this.props;
    const validationsCopy = JSON.parse(JSON.stringify(validations));
    this.props.setValidations(validateAnswer(validationsCopy, value, subType, this.props.optionSettings));
    this.props.setMatrixCorrectAnswer(value);
  };

  _setOptionContent = (value: any) => {    
    const { validations, subType } = this.props;
    const validationsCopy = JSON.parse(JSON.stringify(validations));
    this.props.setValidations(
      validateOptions(validationsCopy, {
        optionContent: { options: value, subType },
        optionSettings: this.props.optionSettings,
      })
    );
    this.props.setOptionsContent(value);
  };

  _setOptionSettings = (type: string, value: any) => {
    const { validations, subType } = this.props;
    this.props.handleOptionSettingsChange(type, value);
    const validationsCopy = JSON.parse(JSON.stringify(validations));

    let optionContent = { options: this.props.optionsContent, subType };
    if (subType === QUESTION_TYPES.MATRIX.toString()) {
      optionContent.options = this.props.matrixOptionContent;
    }
    this.props.setValidations(
      validateOptions(validationsCopy, {
        optionSettings: {
          ...this.props.optionSettings,
          [type]: value,
          subType,
        },
        optionContent,
      })
    );
  };

  _setCorrectAnswer = (value: any) => {
    const { validations, subType } = this.props;
    const validationsCopy = JSON.parse(JSON.stringify(validations));
    this.props.setValidations(validateAnswer(validationsCopy, value, subType));
    this.props.setCorrectAnswer(value);
  };

  _setCustomAnswer = (value: any) => {
    this.props.setCustomAnswer(value);
  };

  _setSubjects = (evt: any,isConceptAvailable: boolean) => {
    const { validations } = this.props;
    const validationsCopy = JSON.parse(JSON.stringify(validations));
    this.props.setValidations(validateSyllabus(validationsCopy, evt, isConceptAvailable));
    this.props.setSubjects(evt);
  };

  _setSecondarySubjects = (evt: any) => {
    this.props.setSecondarySubjects(evt);
  };

  validateQuestionSolutions = (solutions: StepWiseSolution[]) => {
    const { validations, subType } = this.props;
    const validationsCopy = JSON.parse(JSON.stringify(validations)) || {};
    validationsCopy.solutions && this.props.setValidations(
      validateStepWiseSolutions(
        validationsCopy,
        solutions,
        subType === QUESTION_TYPES.DESCRIPTIVE.toString()
      )
    );
  };

  
  _setTags = (evt: any) => {
    const { validations, tagsList } = this.props;
    const validationsCopy = JSON.parse(JSON.stringify(validations));
    this.props.setTags(evt);
  };

  _setQuestionHint = (evt: any) => {
    const { name, value } = evt.target;
    const { validations } = this.props;
    const validationsCopy = JSON.parse(JSON.stringify(validations));
    this.props.setValidations(validateQuestionHint(validationsCopy, value));
    this.props.setQuestionHints(value);
  };

  handleDifficultyAndSkillFormChange = (
    difficulty: string[],
    skill: string[],
    type: string
  ) => {
    const { validations, questionSpecialPurposes } = this.props;
    const difficultyAndSkillValidationsCopy = JSON.parse(JSON.stringify(validations));
    const isDifficultyLevelPresent = !!difficulty.length;
    const isDifficultyTypePresent = !!skill.length;
    const studentUser = getUserType(USER_TYPE.STUDENT);
    if (!questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE) && !studentUser) {
      this.props.setValidations(validateDifficultyAndSkillLevel(difficultyAndSkillValidationsCopy, { isDifficultyLevelPresent, isDifficultyTypePresent }));
    }
    this.props.setDifficultyLevel(difficulty);
    this.props.setDifficultyType(skill);
  };

  handleBenchmarkingFormChange = (benchmarks: any) => {
    const { validations } = this.props;
    const validationsCopy = JSON.parse(JSON.stringify(validations));
    const updatedValidationsCopy = validateBenchmarks(validationsCopy, benchmarks);
    const { error, status } = _.get(validations, 'addBenchmarking', {});
    const { error: updatedError, status: updatedStatus } = _.get(updatedValidationsCopy, 'addBenchmarking', {});
    if (updatedError !== error || updatedStatus !== status) {
      this.props.setValidations(updatedValidationsCopy);
    }
  }

  handleRelevantExamsChange = (relevantExams: any[]) => {
    this.props.setRelevantExams(relevantExams);
  };

  onlyAllowNumbers = (evt: any) => {
    var theEvent = evt;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[0-9]|\./;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  };

  handleClose = () => {
    const { history } = this.props;
    history.push("/");
  };

  getErrorText(sectionType: string) {
    const { validations, subType } = this.props;
    if (
      validations &&
      validations[sectionType] &&
      validations[sectionType].status == statusType.warning
    ) {
      if (sectionType === "optionsContent") {
        if (validations[sectionType].type === "options") {
          return "Option can not be blank.";
        } else if (validations[sectionType].type === "optionSettings") {
          return "Option Settings can not be blank.";
        }
      }
      if (sectionType === "solutions") {
        if (validations[sectionType].type === "step") {
          return "Steps cannot be blank.";
        } else if (validations[sectionType].type === "weightage") {
          if (
            validations[sectionType].isEmptyWeightage &&
            subType === QUESTION_TYPES.DESCRIPTIVE.toString()
          ) {
            return "Weightage cannot be blank";
          } else if (!validations[sectionType].isEmptyWeightage) {
            return "Total Weightage must be equal to 100.";
          }
        }
      }
      switch (sectionType) {
        case "correctAnswer":
          return "All answers must be entered.";
        case "subjects":
          return "Atleast one concept must be mapped.";
        case "optionSettings":
          return "Option settings can not be blank.";
        default:
          return "";
      }
    }
    return "";
  }
  
  // getVariationName = () => {
  //   try {
  //     return (this.props.history.location.search.search('vKey') != -1
  //     && this.props.history.location.search.split('?')[1].split('=')[1]) || ''
  //   } catch(e) {
  //     return ''
  //   }
  // }

  _setIdealTimeChange = (value: any, state: string) => {
    this.props.setIdealTime({ value, state });
  };

  getTimerState(state: number) {
    if (state === 2) return 'min'
    else if (state === 3) return 'hour'
    return 'sec'
  }

  onChangeIdealTime = (e: any, newState?: number) => {
    var regex = /^\d+$/
    let value = e ? e.target.value : this.props.idealTime.value
    if (value === '' || regex.test(value)) {
      value = value ? parseInt(value) : value
      let { state: currState } = this.props.idealTime
      if (newState) {
        currState = newState;
      }
      value = convertTime(
        value,
        this.getTimerState(e ? currState : this.props.idealTime.state),
        this.getTimerState(currState))
      value = value ? parseInt(value) : value

      if (currState >= 1 && currState <= 3) {
        this._setIdealTimeChange(value, currState)
      }
    }
  }

  // onChangeTimeState = (value: number) => {
  //   this.setState({
  //     idealTimeState: value
  //   }, () => {
  //     this._setIdealTimeChange(null)
  //   })
  // }

  render() {
    const {
      classes,
      type,
      subType,
      setAlternateAnswer,
      status,
      alternateAnswer,
      contentId,
      content,
      clickedfeedbackData,
      openFeedback,
      editRights,
      questionSpecialPurposes,
      activeValidationFeedbackSection,
      handleAddCommentInFeedback,
      activeValidationFeedbackData,
      createNewValidationFeedback,
      feedbackActionId,
      showRemedial
    } = this.props;
    const { tag } = this.state;
    let questionId = contentId ? contentId.split("question")[0] : contentId;
    let variationName = `Variation ${getVariationName(this.props.history)}`
    const isFtre = questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE);
    const isGlorifire = questionSpecialPurposes.includes(CONTENT_SECTION_KEYS.GLORIFIRE);
    const studentUser = getUserType(USER_TYPE.STUDENT);
    const showConceptAndChapter = !studentUser || !getPropertyValue(this.props, 'content.validationStatus');
    return (
      <>
      {
        content.masterVariationQuestionId && (
          <VarientQuestionCard content={content} />
        )
      }
        <MyPATExpansionPanel
          isDisable={!editRights.includes('content')}
          hasExpandIcon
          variant="white"
          sectionId="questionContent" // used for scrolling to this section
          customCollapseTitle={
            <>
            
            <Typography variant="h6" className={classes.cardHeading} onClick={(event) => {
              event.stopPropagation();
              this.addFeedback('question')}}>
            <span 
            id={this.props.openFeedback && this.state.tag === "question" ? 'feedbackScroll' : ''}
            className={`${classes.feedbackContainer} ${this.props.openFeedback && this.state.tag === "question" ? classes.blueColor : ''} ${this.props.openFeedback ? classes.feedbackHighlight : ''}`}
            >Create Question
            <span className={classes.requiredHeading}>*  </span>            {/* <img src="/assets/svg/infoIcon/info.svg" /> { content.masterVariationQuestionId && (<span>- {variationName}</span>)} */}
              {this.props.openFeedback && this.state.tag === "question" && (
                <Grid className="feedbackBlock">
                <AddFeedback 
                author={this.props.authorType}
                replyFeedback={this.replyFeedback} closeFeedback={this.closeFeedback} resolveFeedback={this.resolveFeedback} clickedfeedbackData={clickedfeedbackData} addNewFeedback={this.addNewFeedback} />
              </Grid>)}
              {
                activeValidationFeedbackSection === SECTIONS.CONTENT && (
                  <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={handleAddCommentInFeedback} handleCancel={()=>createNewValidationFeedback && createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} feedbackActionId={feedbackActionId}/>
                )
              }
              </span>
              <CustomInfoIcon
                infoDialogContentType="Goal Management"
                isInfoIcon={true}
                isRightArrow={false}
                isCenterArrow={true}
                knowMoreAbout={false}
                dialogTitle="Create Question"
                imageURL="/assets/svg/infoIcon/createQuestion.svg"
                dialogPara="Create a question by entering text, pasting an image, or using the formatting toolbar at the top."
                details="Click to know more"
                toolTipDirection="top" />
            </Typography>
            </>
          }
        >
          <QuestionTitleField
            changeHandler={this._setTitle.bind(this)}
            name="questionContent"
            inputId="createQuestion"
            type={type}
            subType={subType}
            value={this.props.title}
          />
        </MyPATExpansionPanel>
        {subType == "1" ? (
          <>
            <MatrixOptions
              sectionId={QuestionType.OPTIONS_CONTENT}
              changeHandler={this._setMatrixOptionContent}
              name="contentOption"
              inputId="createQuestion"
              type={type}
              subType={subType}
              matrixOptionContent={this.props.matrixOptionContent}
              matrixCorrectAnswer={this.props.correctAnswer}
              optionSettings={this.props.optionSettings}
              handleOptionSettingsChange={this._setOptionSettings}
              error={this.getErrorText("optionsContent") ? true : false}
              errorText={this.getErrorText("optionsContent")}
              tag={tag}
              openFeedback={openFeedback}
              addFeedback={this.addFeedback}
              replyFeedback={this.replyFeedback} 
              closeFeedback={this.closeFeedback} 
              resolveFeedback={this.resolveFeedback}
              clickedfeedbackData={clickedfeedbackData}
              addNewFeedback={this.addNewFeedback}
              authorType={this.props.authorType}
              isDisable={!editRights.includes('options')}
              activeValidationFeedbackSection={activeValidationFeedbackSection}
              activeValidationFeedbackData={activeValidationFeedbackData}
              handleAddCommentInFeedback={handleAddCommentInFeedback}
              createNewValidationFeedback={createNewValidationFeedback}
            />
            <MatrixAnswers
              sectionId={QuestionType.CORRECT_ANSWER}
              changeHandler={this._setMatrixCorrectAnswer}
              name="matrixAnswer"
              inputId="createQuestion"
              type={type}
              subType={subType}
              matrixOptionContent={this.props.matrixOptionContent}
              matrixCorrectAnswer={this.props.correctAnswer}
              onChangeIdealTime={this._setIdealTimeChange}
              idealTime={this.props.idealTime}
              error={this.getErrorText("correctAnswer") ? true : false}
              errorText={this.getErrorText("correctAnswer")}
              tag={tag}
              openFeedback={openFeedback}
              addFeedback={this.addFeedback}
              replyFeedback={this.replyFeedback} 
              closeFeedback={this.closeFeedback} 
              resolveFeedback={this.resolveFeedback}
              clickedfeedbackData={clickedfeedbackData}
              addNewFeedback={this.addNewFeedback}
              authorType={this.props.authorType}
              isDisable={!editRights.includes('answer')}
              isIdealTimeDisabled={!editRights.includes('idealTime')}
              hideIdealTIme={true}
              activeValidationFeedbackSection={activeValidationFeedbackSection}
              activeValidationFeedbackData={activeValidationFeedbackData}
              handleAddCommentInFeedback={handleAddCommentInFeedback}
              createNewValidationFeedback={createNewValidationFeedback}
            />
          </>
        ) : (
          <>
            <ContentOptions
              changeHandler={this._setOptionContent}
              sectionId={QuestionType.OPTIONS_CONTENT}
              name="contentOption"
              inputId="createQuestion"
              type={type}
              subType={subType}
              optionsContent={this.props.optionsContent}
              optionSettings={this.props.optionSettings}
              handleOptionSettingsChange={this._setOptionSettings}
              error={this.getErrorText("optionsContent") ? true : false}
              errorText={this.getErrorText("optionsContent")}
              tag={tag}
              openFeedback={openFeedback}
              addFeedback={this.addFeedback}
              replyFeedback={this.replyFeedback} 
              closeFeedback={this.closeFeedback} 
              resolveFeedback={this.resolveFeedback}
              clickedfeedbackData={clickedfeedbackData}
              addNewFeedback={this.addNewFeedback}
              authorType={this.props.authorType}
              isDisable={!editRights.includes('options')}
              activeValidationFeedbackSection={activeValidationFeedbackSection}
              activeValidationFeedbackData={activeValidationFeedbackData}
              handleAddCommentInFeedback={handleAddCommentInFeedback}
              createNewValidationFeedback={createNewValidationFeedback}
              
            />
            <ContentAnswer
              customAnswer={this.props.customAnswer}
              updateCustomAnswer={this._setCustomAnswer}
              changeHandler={this._setCorrectAnswer}
              isValidAttempts={this.props.isValidAttempts}
              onChangeIdealTime={this._setIdealTimeChange}
              idealTime={this.props.idealTime}
              name="contentAnswer"
              inputId="createQuestion"
              type={type}
              subType={subType}
              status={status}
              alternateAnswer={alternateAnswer}
              setAlternateAnswer={setAlternateAnswer}
              optionsContent={this.props.optionsContent}
              correctAnswer={this.props.correctAnswer}
              error={this.getErrorText("correctAnswer") ? true : false}
              errorText={this.getErrorText("correctAnswer")}
              tag={tag}
              sectionId={QuestionType.CORRECT_ANSWER}
              openFeedback={openFeedback}
              addFeedback={this.addFeedback}
              replyFeedback={this.replyFeedback} 
              closeFeedback={this.closeFeedback} 
              resolveFeedback={this.resolveFeedback}
              clickedfeedbackData={clickedfeedbackData}
              addNewFeedback={this.addNewFeedback}
              authorType={this.props.authorType}
              isDisable={!editRights.includes('answer')}
              isIdealTimeDisabled={!editRights.includes('idealTime')}
              hideIdealTIme={true}
              activeValidationFeedbackSection={activeValidationFeedbackSection}
              activeValidationFeedbackData={activeValidationFeedbackData}
              handleAddCommentInFeedback={handleAddCommentInFeedback}
              createNewValidationFeedback={createNewValidationFeedback}
            />
          </>
        )}

        <QuestionsSolution
          onChange={this.validateQuestionSolutions}
          subType={subType}
          questionIndex={0}
          showWeightage={subType === QUESTION_TYPES.DESCRIPTIVE.toString()}
          error={this.getErrorText("solutions") ? true : false}
          errorText={this.getErrorText("solutions")}
          tag={tag}
          openFeedback={openFeedback}
          addFeedback={this.addFeedback}
          replyFeedback={this.replyFeedback} 
          closeFeedback={this.closeFeedback} 
          resolveFeedback={this.resolveFeedback}
          clickedfeedbackData={clickedfeedbackData}
          addNewFeedback={this.addNewFeedback}
          authorType={this.props.authorType}
          isDisable={!editRights.includes('solution')}
          activeValidationFeedbackSection={activeValidationFeedbackSection}
          activeValidationFeedbackData={activeValidationFeedbackData}
          handleAddCommentInFeedback={handleAddCommentInFeedback}
          createNewValidationFeedback={createNewValidationFeedback}
        />

        { showConceptAndChapter && <AddConceptOrChapter
          defaultExpanded={true}
          // TODO - need to fix it later
          formData={JSON.parse(JSON.stringify(this.props.subjects))}
          handleFormChange={this._setSubjects}
          allowSecondarySubjects
          secondarySubjects={JSON.parse(
            JSON.stringify(this.props.secondarySubjects)
          )}
          handleSecondarySubjectChange={this._setSecondarySubjects}
          error={this.getErrorText("subjects") ? true : false}
          errorText={this.getErrorText("subjects")}    
          isDisable={(content.masterVariationQuestionId || !editRights.includes('syllabus')) ? true : false}
          tag={tag}
          openFeedback={openFeedback}
          addFeedback={this.addFeedback}
          replyFeedback={this.replyFeedback} 
          closeFeedback={this.closeFeedback} 
          resolveFeedback={this.resolveFeedback}
          clickedfeedbackData={clickedfeedbackData}
          addNewFeedback={this.addNewFeedback}
          authorType={this.props.authorType}
          contentType={CONTENT_TYPE.QUESTION}
          questionId={questionId}
          goalMandatory
          activeValidationFeedbackSection={activeValidationFeedbackSection}
          activeValidationFeedbackData={activeValidationFeedbackData}
          handleAddCommentInFeedback={handleAddCommentInFeedback}
          createNewValidationFeedback={createNewValidationFeedback}
        />}

        { !isGlorifire && !this.isStudentUser &&
          <AddBenchmarking
            defaultExpanded={true}
            questionId={questionId}
            subjects={this.props.subjects}
            handleFormChange={this.handleBenchmarkingFormChange}
            isDisable={(content.masterVariationQuestionId || !editRights.includes('benchmarking') ) ? true : false}
            activeValidationFeedbackSection={activeValidationFeedbackSection}
            activeValidationFeedbackData={activeValidationFeedbackData}
            handleAddCommentInFeedback={handleAddCommentInFeedback}
            createNewValidationFeedback={createNewValidationFeedback}
          />
        }
        <AddDifficultyAndSkill
          defaultExpanded={!isFtre}
          difficultyType={this.props.difficultyType}
          difficultyLevel={this.props.difficultyLevel}
          handleFormChange={this.handleDifficultyAndSkillFormChange}
          isDisable={(content.masterVariationQuestionId || !editRights.includes('difficulty') )? true : false}
          tag={tag}
          openFeedback={openFeedback}
          addFeedback={this.addFeedback}
          replyFeedback={this.replyFeedback} 
          closeFeedback={this.closeFeedback} 
          resolveFeedback={this.resolveFeedback}
          clickedfeedbackData={clickedfeedbackData}
          addNewFeedback={this.addNewFeedback}
          authorType={this.props.authorType}
          isNotMandatory={isFtre || studentUser}
          activeValidationFeedbackSection={activeValidationFeedbackSection}
          activeValidationFeedbackData={activeValidationFeedbackData}
          handleAddCommentInFeedback={handleAddCommentInFeedback}
          createNewValidationFeedback={createNewValidationFeedback}
        />

        {!this.isStudentUser && 
          <SetIdealTime
            addFeedback={this.addFeedback}
            openFeedback={this.props.openFeedback}
            checkFeedback={() =>
              this.props.openFeedback &&
              tag === "idealTime"
            }
            idealTime={this.props.idealTime}
            isDisable={!editRights.includes('idealTime')}
            onChangeIdealTime={this.onChangeIdealTime}
            authorType={this.props.authorType}
            replyFeedback={this.replyFeedback}
            closeFeedback={this.closeFeedback}
            resolveFeedback={this.resolveFeedback}
            clickedfeedbackData={clickedfeedbackData}
            addNewFeedback={this.addNewFeedback}
            activeValidationFeedbackSection={activeValidationFeedbackSection}
            activeValidationFeedbackData={activeValidationFeedbackData}
            handleAddCommentInFeedback={handleAddCommentInFeedback}
            createNewValidationFeedback={createNewValidationFeedback}
          />
        }

        {!this.isStudentUser && 
          <Hints
            defaultExpanded={true}
            inputId="hints"
            formData={this.props.questionHints}
            handleFormChange={(e: any) => this._setQuestionHint(e)}
            value={this.props.questionHints}
            tag={tag}
            openFeedback={openFeedback}
            addFeedback={this.addFeedback}
            replyFeedback={this.replyFeedback} 
            closeFeedback={this.closeFeedback} 
            resolveFeedback={this.resolveFeedback}
            clickedfeedbackData={clickedfeedbackData}
            addNewFeedback={this.addNewFeedback}
            authorType={this.props.authorType}
            placeholder="Describe the hint that leads to solution"
            isDisable={!editRights.includes('hints')}
            isOptional={true}
            activeValidationFeedbackSection={activeValidationFeedbackSection}
            activeValidationFeedbackData={activeValidationFeedbackData}
            handleAddCommentInFeedback={handleAddCommentInFeedback}
            createNewValidationFeedback={createNewValidationFeedback}
          />
        }

        {!this.isStudentUser && 
          <RelevantExams
            isOptional={true}
            relevantExams={this.props.relevantExams}
            handleRelevantExamsChange={this.handleRelevantExamsChange}
            isDisable={(content.masterVariationQuestionId || !editRights.includes('relevantExams') ) ? true : false}
            tag={tag}
            openFeedback={openFeedback}
            addFeedback={this.addFeedback}
            replyFeedback={this.replyFeedback} 
            closeFeedback={this.closeFeedback} 
            resolveFeedback={this.resolveFeedback}
            clickedfeedbackData={clickedfeedbackData}
            addNewFeedback={this.addNewFeedback}
            authorType={this.props.authorType}
            questionSubType={subType}
            activeValidationFeedbackSection={activeValidationFeedbackSection}
            activeValidationFeedbackData={activeValidationFeedbackData}
            handleAddCommentInFeedback={handleAddCommentInFeedback}
            createNewValidationFeedback={createNewValidationFeedback}
          />
        }
        { isGlorifire && !this.isStudentUser &&
        <AddBenchmarking
          questionId={questionId}
          subjects={this.props.subjects}
          isDisable={(content.masterVariationQuestionId || !editRights.includes('benchmarking') ) ? true : false}
          activeValidationFeedbackSection={activeValidationFeedbackSection}
          activeValidationFeedbackData={activeValidationFeedbackData}
          handleAddCommentInFeedback={handleAddCommentInFeedback}
          createNewValidationFeedback={createNewValidationFeedback}
        />
        }
        {showRemedial && !this.isStudentUser && <RemedialQuestion QuestionId={questionId} QuestionTypeCode={+subType} remedialKey={PROPS_REMEDIAL_KEY.DEFAULT} />}
        {!this.isStudentUser && 
          <PreviousYearQuestion
            questionId={questionId}
            subjects={this.props.subjects}
            isDisable={(content.masterVariationQuestionId) ? true : false}
          />
        }
        {!this.isStudentUser && 
          <AddExtraTags
            // TODO- change formData name later
            formData={this.props.tags}
            defaultExpanded={true}
            handleFormChange={this._setTags}
            contentType={type}
            isDisable={(content.masterVariationQuestionId || !editRights.includes('tags') ) ? true : false}
            tag={tag}
            openFeedback={openFeedback}
            addFeedback={this.addFeedback}
            replyFeedback={this.replyFeedback} 
            closeFeedback={this.closeFeedback} 
            resolveFeedback={this.resolveFeedback}
            clickedfeedbackData={clickedfeedbackData}
            addNewFeedback={this.addNewFeedback}
            authorType={this.props.authorType}
            activeValidationFeedbackSection={activeValidationFeedbackSection}
            activeValidationFeedbackData={activeValidationFeedbackData}
            handleAddCommentInFeedback={handleAddCommentInFeedback}
            createNewValidationFeedback={createNewValidationFeedback}
          />
        }
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  title: state.questionCreate.title,
  optionsContent: state.questionCreate.optionsContent,
  correctAnswer: state.questionCreate.correctAnswer,
  customAnswer: state.questionCreate.customAnswer,
  questionHints: state.questionCreate.questionHints,
  subjects: state.questionCreate.subjects,
  secondarySubjects: state.questionCreate.secondarySubjects,
  difficultyLevel: state.questionCreate.difficultyLevel,
  difficultyType: state.questionCreate.difficultyType,
  relevantExams: state.questionCreate.relevantExams,
  tags: state.questionCreate.tags,
  matrixOptionContent: state.questionCreate.matrixOptionContent,
  alternateAnswer: state.questionCreate.alternateAnswer,
  validations: state.questionCreate.validations,
  isValidAttempts: state.questionCreate.isValidAttempts,
  tagsList: _.get(state, "mylibraryData.contentTags.list", []),
  idealTime: _.get(state, "questionCreate.idealTime", {}),
  editRights: _.get(state, 'questionCreate.editRights', []),
  questionSpecialPurposes: state.questionCreate.specialPurposes,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      updateContent: contentActions.updateContent,
      eventFired,
      setTitle: questionActions.setTitle,
      setOptionsContent: questionActions.setOptionsContent,
      setCorrectAnswer: questionActions.setCorrectAnswer,
      setCustomAnswer: questionActions.setCustomAnswer,
      setSubjects: questionActions.setSubjects,
      setSecondarySubjects: questionActions.setSecondarySubjects,
      setTags: questionActions.setTags,
      setQuestionHints: questionActions.setQuestionHints,
      setDifficultyLevel: questionActions.setDifficultyLevel,
      setDifficultyType: questionActions.setDifficultyType,
      setRelevantExams: questionActions.setRelevantExams,
      setMatrixOptionsContent: questionActions.setMatrixOptionsContent,
      setMatrixCorrectAnswer: questionActions.setMatrixCorrectAnswer,
      setValidations: questionActions.setValidations,
      setAlternateAnswer: questionActions.setAlternateAnswer,
      setIdealTime: questionActions.setIdealTime,
      addNewFeedback: addNewFeedback,
      resolveFeedback: resolveFeedback,
      replyFeedback: replyFeedback,
      setRemedialInitialState: remedialQuestionActions.setInitialState
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(MultipleChoiceCreate));